// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `pnpm build-icons` instead of editing. */ import { ReactComponent as XCloseDefault } from '../../../../../ui/src/assets/icons/v2.1/mono-tone/default/general/x-close.svg?react';
import { ReactComponent as XCloseSolid } from '../../../../../ui/src/assets/icons/v2.1/mono-tone/solid/general/x-close.svg?react';
import { createIcons } from '../../Icon';
export const XCloseIcon = /* @__PURE__ */ createIcons('XClose', {
    default: XCloseDefault,
    solid: XCloseSolid
});
XCloseIcon.supportedTypes = [
    'default',
    'solid'
];
